import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Credentials } from '@model';
import { GlobalAlertService, PasswordService } from '@service';

@Component({
  selector: 'login-generate-password-form',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./generate-password-form.component.scss'],
  templateUrl: './generate-password-form.component.html',
})
export class GeneratePasswordFormComponent {
  generatedPassword = '';

  resetUserPasswordForm: FormGroup = new FormGroup({
    username: new FormControl('', Validators.required),
  });

  constructor(
    private passwordService: PasswordService,
    private globalAlertService: GlobalAlertService,
    private route: Router,
  ) {}

  get credentials(): Credentials {
    return { ...this.resetUserPasswordForm.getRawValue() } as Credentials;
  }

  generatePassword(): void {
    try {
      this.passwordService.generatePassword(this.credentials).subscribe(results => {
        if (results?.password) {
          this.generatedPassword = results.password;
          this.globalAlertService.setSuccess('Password successfully generated.  Please copy the generated password.');
        } else {
          this.globalAlertService.setError('An error occurred generating a password: ', results.message);
        }
      });
    } catch (err) {
      this.globalAlertService.setError('An error occurred generating a password: ', err);
    }
  }

  goBack() {
    this.route.navigate(['/']);
  }
}
